import {NETWORK_URLS} from '../constants/NetworkConstants';
import { apiUrl, headerHelper } from '../helper/Utility'

export default class DiscountCodeService {

  // DICOUNT CODE VALIDATION

  static validate = async (code,email,token) => {
    var endpointReplaced = NETWORK_URLS.discount_codes.replace('usercode',code);
    var endpoint= endpointReplaced.replace('useremail',email);
    var encodedUrl = apiUrl()+endpoint;

    try {
      var response = await fetch(encodedUrl,{method: 'GET', headers: headerHelper(token)});
      var responseJson = await response.json();
      return responseJson;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  static apply = async (code,email,token) => {
    var endpoint = NETWORK_URLS.apply_discount.replace('cart_token',token);
    var encodedUrl = apiUrl()+endpoint;
    var data = {discount: {code: code, email: email, cart_token: token}}

    try {
      var response = await fetch(encodedUrl,{method: 'POST', headers: headerHelper(token), body: JSON.stringify(data)});
      var responseJson = await response.json();
      return responseJson;
    } catch (e) {
      console.log(e);
      return [];
    }
  }
}
